import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { contactEmail, instagramUrl, productName } from '../data/content';
export function Footer() {
  return <footer className="bg-plum-950 px-4 py-12" data-id="element-105" data-mp="3gh3n22klrk9c">
      <div className="mx-auto max-w-4xl text-center" data-id="element-106" data-mp="32ovz90bar3ms">
        <p className="font-display text-base font-black uppercase tracking-[.2em] text-blush-300" data-id="element-107" data-mp="36pfu1x8edv5r">Bright Digital Hub</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/80" data-id="element-108" data-mp="3ueiltxwqx4dz">
          Digital crochet patterns, creative collections, and practical resources for people who love making beautiful
          handmade projects.
        </p>
        <p className="mt-5 text-sm font-black uppercase text-white" data-id="element-109" data-mp="3le2iqpjwzz9n">{productName}</p>
        <div className="mt-5 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-white/85 sm:flex-row sm:gap-6" data-id="element-110" data-mp="3qc3yp1m1nigw">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-blush-300" href={`mailto:${contactEmail}`} data-id="element-111" data-mp="2a1jjpa3jzw2z">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="3lbmtfq7jj4eu" /> Customer Support: {contactEmail}
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-blush-300" href={instagramUrl} target="_blank" rel="noopener noreferrer" data-id="element-113" data-mp="3gctpaoe58prc">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="828mc4dy418m" /> Bright Digital Hub
          </a>
        </div>
        <div className="mt-8 space-y-2 border-t border-white/10 pt-6 text-xs text-white/65" data-id="element-115" data-mp="335szh7bvjgh">
          <p data-id="element-116" data-mp="hrs7xht1m976">© 2026 Bright Digital Hub — All Rights Reserved.</p>
          <p data-id="element-117" data-mp="cu0fmmohkl2g">This is a digital crochet pattern collection. No physical products or crafting materials are included.</p>
          <p data-id="element-118" data-mp="qsqdi4j4qorv">
            Crochet knowledge is required. Finished measurements and results may vary depending on yarn, hook size,
            crochet tension, and individual modifications.
          </p>
          <p data-id="element-119" data-mp="tvw7cfth7dfg">
            Unauthorized copying, reproduction, resale, or redistribution of the digital pattern files is prohibited
            without express permission.
          </p>
        </div>
      </div>
    </footer>;
}